<template>
	<v-container>
		<v-form ref="form" v-model="valid" @submit.prevent="dialogSend = true">
			<v-row class="contentRow">
				<!--'Question Number' icon-->
				<v-col cols="12">
					<v-avatar class="float-left d-none d-md-block" style="position:absolute;" color="grey" size="85">
						<v-img v-if="logo" width="300" :src="logo" />
						<v-icon v-else size="43">fas fa-building</v-icon>
					</v-avatar>
					<h2 v-if="edit" class="font-weight-medium text-center">RESUBMIT AUDIT</h2>
					<h2 v-else class="font-weight-medium text-center">FILL OUT AUDIT</h2>
					<h1 class="font-weight-bold" v-if="edit">Resent to you by: {{sender}}</h1>
					<h1 class="font-weight-bold" v-else>Sent by {{ sender }}</h1>
					<v-alert
						v-if="comment"
						icon="fas fa-pencil"
						border="left"
						color="blue-grey"
						light
						dense
						outlined
						text
						class="mt-5 mb-0"
					>
						<b>Reason provided for edit request by {{sender}}:</b><br />
						<p>{{comment}}</p>
					</v-alert>
					
				</v-col>
			</v-row>
			<div v-for="(question, index) in questions" v-bind:key="index">
				<v-row v-if="shouldDisplay(index)" class="mx-auto">
					<div v-if="index == 0" />
					<v-row no-gutters class="my-12" v-else-if="question.type == 'spacer'">
					</v-row>
					<v-row
						no-gutters
						v-else-if="question.type == 'title'"
						class="contentRow primary"
					>
						<v-col cols="6" class="mr-auto white--text">
							<h2>{{ question.name }}</h2>
						</v-col>
						<!-- Details/hint expanding field -->
						<v-col cols="12">
							<v-btn
								class="my-3"
								dark
								text
								v-if="!!question.hint"
								@click.stop="toggleHint(index)"
							>
								{{ !!question.hintVisible ? "Hide" : "Show" }}
								Question Details
								<v-icon right>far fa-question-circle</v-icon>
							</v-btn>
						</v-col>

						<v-col cols="12" v-if="!!question.hintVisible">
							<v-card outlined class="my-3 white--text">
								<v-card-text style="white-space: pre-wrap">{{
									question.hint
								}}</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12">
							<p class="float-right white--text text-caption">
								<i>(Question ID {{ index }})</i>
							</p>
						</v-col>
					</v-row>
					<v-row
						no-gutters
						align="center"
						v-else-if="question.type == 'attachment'"
						class="contentRow secondary"
						dark
					>
						<v-col cols="6" class="mr-auto white--text">
							<h2>
								<v-icon dark left>fas fa-file-download</v-icon
								>{{ question.name }}
							</h2>
						</v-col>
						<!--'File uplad' text field-->
						<v-col cols="12" class="white--text">
							<p class="mt-2">
								<i>The Auditor has provided file(s) for you to download:</i>
							</p>
							<file-uploader
								:value="question.fileID"
								:readonly="true"
								:disabled="true"
								:dark="true"
								:name="question.name"
							/>
						</v-col>
						<!-- Details/hint expanding field -->
						<v-col cols="12">
							<v-btn
								class="my-3"
								dark
								text
								v-if="!!question.hint"
								@click.stop="toggleHint(index)"
							>
								{{ !!question.hintVisible ? "Hide" : "Show" }}
								Question Details
								<v-icon right>far fa-question-circle</v-icon>
							</v-btn>
						</v-col>
						<v-col cols="12" v-if="!!question.hintVisible">
							<v-card outlined class="my-3 white--text">
								<v-card-text style="white-space: pre-wrap">{{
									question.hint
								}}</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12">
							<p class="float-right grey--text text-caption">
								<i>(Question ID {{ index }})</i>
							</p>
						</v-col>
					</v-row>
					<v-row class="contentRow" align="center" no-gutters v-else>
						<!--'Question Number' icon-->
						<!-- <v-col cols="1" v-if="question.type != 'title'">
						<v-avatar dense tile color="secondary">
							<h3 class="white--text">#{{index}}</h3>
						</v-avatar>
						</v-col>-->
						<!--'Title Name' label-->
						<!--'Question Name' label-->
						<v-col cols="12">
							<h3 class="my-3">
								{{ question.name
								}}<sup v-if="!!question.required"
									><v-icon color="error" x-small right
										>fas fa-asterisk</v-icon
									></sup
								>
							</h3>
						</v-col>
						<!--'Question Name' text field-->
						<v-col cols="12" v-if="question.type == 'singleanswer'">
							<v-text-field
								dense
								align="center"
								label="Answer"
								hide-details="auto"
								placeholder="Enter your answer:"
								:rules="question.required ? notEmptyRules : []"
								outlined
								v-model="answers[index]"
								class="my-3"
							></v-text-field>
						</v-col>
						<!--'Dependency Question' text field-->
						<v-col cols="12" v-if="question.type == 'multiplechoice'">
							<v-select
								dense
								outlined
								v-model="answers[index]"
								:items="question.possibilities"
								menu-props="auto"
								label="Please Choose"
								hide-details="auto"
								single-line
								:rules="question.required ? notEmptyRules : []"
								class="my-3 text-wrap"
							>
								<template v-slot:item="{ item }">
									<span class="py-2">
										<v-avatar color="primary" size="5" class="mr-3"></v-avatar>
										{{ item }}</span
									>
								</template>
							</v-select>
						</v-col>
						<!--'Dependency Question' text field-->
						<v-col cols="12" v-if="question.type == 'multipleanswers'">
							<v-select
								dense
								outlined
								multiple
								v-model="answers[index]"
								:items="question.possibilities"
								menu-props="auto"
								label="Please Choose"
								hide-details="auto"
								single-line
								:rules="question.required ? notEmptyRules : []"
								class="my-3 text-wrap"
							>
								<template v-slot:item="{ active, item, attrs, on }">
									<v-list-item v-on="on" v-bind="attrs" #default="{ active }">
										<v-checkbox
											color="primary"
											size="5"
											class="mr-3"
											:input-value="active"
										/>{{ item }}
									</v-list-item>
								</template>
							</v-select>
						</v-col>
						<!--'File uplad' text field-->
						<v-col cols="12" v-if="question.type == 'file'">
							<file-uploader
								v-model="answers[index]"
								:rules="question.required ? notEmptyRules : []"
								@filesChanged="saveAudit()"
							/>
						</v-col>
						<!-- Details/hint expanding field -->
						<v-col cols="12">
							<v-btn
								class="my-3"
								text
								v-if="!!question.hint"
								@click.stop="toggleHint(index)"
							>
								{{ !!question.hintVisible ? "Hide" : "Show" }}
								Question Details
								<v-icon right>far fa-question-circle</v-icon>
							</v-btn>
						</v-col>

						<v-col cols="12" v-if="!!question.hintVisible">
							<v-card outlined class="my-3">
								<v-card-text style="white-space: pre-wrap" v-if="question.type == 'policyLink'">
									<span v-html="formatPolicyLinkHint(question.hint)"></span>
								</v-card-text>
								<v-card-text style="white-space: pre-wrap" v-else>{{
									question.hint
								}}</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12">
							<p class="float-right grey--text text-caption">
								<i>(Question ID {{ index }})</i>
							</p>
						</v-col>
					</v-row>
				</v-row>
			</div>
			<v-row
				no-gutters
				class="contentRow"
				style="border: 2px solid #4CAF50; /*#3d2645*/"
			>
				<v-col cols="12" class="mr-auto">
					<h2>Ready to send?</h2>
					<p>
						Note: You will not be able to change your answers at a later time.
					</p>
					<v-btn
						color="success"
						:disabled="!valid"
						type="submit"
						align="center"
						class="mt-4"
					>
						Submit Audit
						<v-icon right>fas fa-paper-plane</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-tooltip left>
				<template v-slot:activator="{ on, attrs }">
					<v-fab-transition>
						<v-btn
							color="success"
							x-large
							rounded
							dark
							bottom
							right
							fixed
							:style="
								unsaved
									? 'border: 2pt outset black; border-color: var(--v-warning-base) !important; '
									: ''
							"
							v-on="on"
							v-bind="attrs"
							@click="saveAudit"
						>
							<v-icon left>fas fa-sync</v-icon>Save
						</v-btn>
					</v-fab-transition>
				</template>
				<span
					>Audit is saved automatically{{
						unsaved ? " - You have unsaved changes!" : ""
					}}</span
				>
			</v-tooltip>
		</v-form>
		<v-dialog v-model="dialogSend" max-width="600px">
			<v-card>
				<v-card-title class="justify-center"><span class="text-h5 font-weight-bold pt-12">Are you sure?</span></v-card-title>
				<v-card-text class="text-center"><span class="black--text">You will not be able to change your answers at a later time.</span></v-card-text>
				<v-card-actions class="justify-center">
					<v-btn outlined class="ma-2" color="primary" @click="dialogSend = false">CANCEL</v-btn>
					<v-btn color="orangeButton" dark class="ma-2" @click="sendAudit()">SUBMIT AUDIT</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import RequestAPI from "../../api/audit/request"
import router from "../../router"
import LoadingState from "../../consts/LoadingState"
import AuditAPI from "../../api/audit/audit"
import FilesAPI from "../../api/files/files"
import FileUploaderVue from "../../components/FileUploader.vue"
export default {
	name: "AuditInput",
	components: {
		"file-uploader": FileUploaderVue
	},
	data() {
		return {
			sheet: false,
			notEmptyRules: [v => !!v || "This field cannot be empty"],
			valid: false,
			questions: null,
			answers: [],
			files: [],
			name: "Audit",
			sender: "auditor",
			id: null,
			fileID: null,
			savedAnswers: [],
			comment: null,
			edit: false,
			auditID: null,
			dialogSend: false,
			lastSaveDate: 0,
			logo: null
		}
	},
	mounted() {
		if (isNaN(parseInt(this.$route.params.id))) {
			router.push("/")
		} else {
			this.id = parseInt(this.$route.params.id)
			this.loadAudit()
		}
	},
	computed: {
		unsaved() {
			/*console.log(
				`Same length: ${this.answers.length ==
					this.savedAnswers.length} (length ${this.answers.length}, ${
					this.savedAnswers.length
				})`
			)*/
			let equal =
				this.answers.length == this.savedAnswers.length &&
				this.answers.every((e, i) => {
					//console.log(`e: ${e};`)
					//console.log(`savedanswers[i]: ${this.savedAnswers[i]};`)
					//console.log(`equal: ${e + "" == this.savedAnswers[i] + ""}`)
					return e + "" == this.savedAnswers[i] + ""
				})
			return !equal
		}
	},
	methods: {
		formatPolicyLinkHint(hint) {
			const matchText = /"([^"]+)"/
			const match = hint.match(matchText)
			
			if (match) {
				const linkText = match[1]     		// Text inside the quotation marks
				const link = `<a href="${linkText}" target="_blank">Policy & Certificate Link</a>`
				return hint.replace(`"${linkText}"`, `"${link}"`)   		// Replace the text inside quotes with the anchor link
			}

			// If no quotation marks are found, return the original hint
			return hint
		},
		loadAudit() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			RequestAPI.get(this.id)
				.then(data => {
					if (data.filledOut) {
						this.$router.push({
							name: "Audit Details",
							params: {
								id: data.auditID
							}
						})

						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							null,
							{ root: true }
						)

						return
					} else if (data.auditID === null) {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							"This audit has already been filled out!",
							{ root: true }
						)
						return
					}

					this.name = data.name
					this.id = data.id
					this.questions = data.questions
					this.fileID = data.fileID
					this.edit = data.edit
					this.comment = data.comment
					this.auditID = data.auditID
					this.sender = data.senderName
					this.answers = []
					this.savedAnswers = []
					this.files = []
					for (let i = 0; i < this.questions.length; i++) {
						this.answers.push(null)
						this.savedAnswers.push(null)
						this.files.push(null)
					}

					if (data.answers) {
						this.answers = data.answers
						this.savedAnswers = JSON.parse(JSON.stringify(data.answers))
					}
					this.logo = data.logoURL

					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		fileChanged(index) {
			FilesAPI.createFile(this.files[index].name, this.files[index])
				.then(file => {
					this.$set(this.answers, index, file.id)
				})
				.catch(err => {
					this.files[index] = null
					console.error(err)
				})
		},
		removeFile(index) {
			FilesAPI.deleteFile(this.answers[index])
				.then(() => {
					this.$set(this.answers, index, null)
				})
				.catch(err => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
				})
		},
		downloadFile(fileID, name) {
			FilesAPI.download("" + fileID, name)
		},
		shouldDisplay(index) {
			if (!this.questions[index].dependencyQuestionID) {
				return true
			}
			if (!this.answers[this.questions[index].dependencyQuestionID]) {
				return false
			}
			if (
				this.questions[index].dependencyQuestionValue.includes(
					this.answers[this.questions[index].dependencyQuestionID]
				)
			) {
				return true
			}

			if (
				typeof this.answers[this.questions[index].dependencyQuestionID] ==
				"object"
			) {
				for (let element of this.answers[
					this.questions[index].dependencyQuestionID
				]) {
					if (this.questions[index].dependencyQuestionValue.includes(element)) {
						return true
					}
				}
			}
			return false
		},
		sendAudit() {
			this.lastSaveDate = Date.now() + 10000
			AuditAPI.addAudit(this.id, this.answers,null,0,null)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully completed audit with ID '${data}'`,
						{ root: true }
					)
					router.push(`/audit/submitter/${this.id}/success`)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		saveAudit(fromTimeout) {
			fromTimeout = fromTimeout || false
			if (Date.now() - this.lastSaveDate < 2000) {
				//ignore autosave more often than 3seconds
				console.log(`Tried to save too close to previous date. Diff was: ${+Date.now() - this.lastSaveDate}`)
				return
			}
			this.savedAnswers = JSON.parse(JSON.stringify(this.answers))
			this.lastSaveDate = Date.now()
			RequestAPI.updateRequest(this.id, this.answers)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully saved audit draft!`,
						{ root: true }
					)
					if (fromTimeout) {
						return
					}
					setTimeout(()=>{
						this.saveAudit(true)
					}, 3500)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		toggleHint(index) {
			let source = { hintVisible: !this.questions[index].hintVisible }
			let newQuestion = Object.assign({}, this.questions[index], source)
			this.$set(this.questions, index, newQuestion)
		}
	},
	watch:{
		answers(){
			this.saveAudit()
		}
	}
}
</script>
